import { CachePolicyWithoutEquality } from 'recoil';

/**
 * For a selector with an input that changes on every mouse move. Recoil's
 * default cache keeps every input value it has seen, by reference, for the
 * life of the root; this keeps only the latest computation.
 */
export const KEEP_LATEST_ONLY: CachePolicyWithoutEquality = {
    eviction: 'most-recent',
};
